import { SalesReportSearchForm } from './SalesReportSearchForm'
import { withSalesReportSearchForm } from './withSalesReportSearchForm'

const ConnectedSalesReportSearchForm = withSalesReportSearchForm(
  SalesReportSearchForm
)

export { ConnectedSalesReportSearchForm as SalesReportSearchForm }
